import { TooltipText } from "@/components/ui/tooltip";
import { Edit2, Check, Trash2, Ban, Printer, Mail, SquarePen } from "lucide-react";
import { getInvoiceMetadataDivision } from "@/utils/accountingBookingUtils";

export const getBillColumns = (handlers) => {
  const {
    openEditModal,
    handleApprove,
    handleDelete,
    handleVoid,
    formatDate,
    formatCurrency,
    STATUS_CONFIG,
    onMail,
    onPrint,
  } = handlers;

  return [
    {
      key: "bill_no",
      label: "BILL #",
      render: (bill) => (
        <span className="text-sm font-medium text-sky-600">
          {bill.bill_no}
        </span>
      ),
    },
    {
      key: "bill_date",
      label: "DATE",
      render: (bill) => (
        <span className="text-sm">
          {formatDate(bill.bill_date)}
        </span>
      ),
    },
    {
      key: "due_date",
      label: "DUE DATE",
      render: (bill) => (
        <span className="text-sm">
          {formatDate(bill.due_date)}
        </span>
      ),
    },
    {
      key: "vendor_name",
      label: "VENDOR",
      render: (bill) => (
        <span className="text-sm">
          {bill.vendor_name || "-"}
        </span>
      ),
    },
    {
      key: "vendor_invoice_no",
      label: "VENDOR INV #",
      render: (bill) => (
        <span className="text-sm">
          {bill.vendor_invoice_no || "-"}
        </span>
      ),
    },
    {
      key: "division",
      label: "DIVISION",
      render: (bill) => (
        <span className="text-sm">
          {bill.metadata?.division ||
            getInvoiceMetadataDivision(bill.division) ||
            bill.division ||
            "-"}
        </span>
      ),
    },
    {
      key: "total_amount",
      label: "AMOUNT",
      align: "right",
      render: (bill) => (
        <span className="text-sm font-medium text-right">
          {formatCurrency(bill.total_amount)}
        </span>
      ),
    },
    {
      key: "balance_due",
      label: "BALANCE",
      align: "right",
      render: (bill) => (
        <span className="text-sm font-medium text-right">
          {formatCurrency(bill.balance_due)}
        </span>
      ),
    },
    {
      key: "status",
      label: "STATUS",
      render: (bill) => {
        const statusConfig =
          STATUS_CONFIG[bill.status] || STATUS_CONFIG.draft;
        const StatusIcon = statusConfig.icon;

        return (
          <span
            className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${statusConfig.color} bg-opacity-20 ${statusConfig.color.replace(
              "bg-",
              "text-"
            )}`}
          >
            <StatusIcon className="w-3 h-3" />
            {statusConfig.label}
          </span>
        );
      },
    },
    {
      key: "actions",
      label: "ACTIONS",
      render: (bill) => (
        <div className="flex items-center justify-center gap-1">
              <TooltipText content={"Edit Bill"}>
          <button
            onClick={() => openEditModal(bill)}
            className="p-1.5 rounded hover:bg-blue-100 dark:hover:bg-blue-900/30 text-blue-600"
          >
          <SquarePen className="h-4 w-4" />
          </button>
          </TooltipText>
             <TooltipText content={"Print Bill"}>
          <button
            onClick={() => onPrint(bill)}
            className="p-1.5 rounded hover:bg-green-100 dark:hover:bg-green-900/30 text-green-600"
          >
                   <Printer className="h-4 w-4" />
          </button>
          </TooltipText>
             <TooltipText content={"Mail Bill"}>
          <button
            onClick={() => onMail(bill)}
            className="p-1.5 rounded hover:bg-purple-100 dark:hover:bg-purple-900/30 text-purple-600"
          >
               <Mail className="h-4 w-4" />
          </button>
          </TooltipText>

          {/* APPROVE */}
          {["draft", "pending"].includes(bill.status) && (
            <button
              onClick={() => handleApprove(bill.id, bill.division)}
              className="p-1.5 rounded-lg hover:bg-green-100 text-green-600"
            >
              <Check className="w-4 h-4" />
            </button>
          )}

          {/* DELETE */}
          {bill.status === "draft" && (
            <TooltipText content="Delete Bill">
              <button
                onClick={() => handleDelete(bill.id, bill.division)}
                className="p-1.5 rounded hover:bg-red-100 dark:hover:bg-red-900/30 text-red-600"
              >
                <Trash2 className="w-4 h-4" />
              </button>
              </TooltipText>
          )}

          {/* VOID */}
          {["draft", "pending", "approved"].includes(bill.status) &&
            bill.paid_amount === 0 && (
              <button
                onClick={() => handleVoid(bill.id, bill.division)}
                className="p-1.5 rounded-lg hover:bg-amber-100 text-amber-600"
              >
                <Ban className="w-4 h-4" />
              </button>
            )}
        </div>
      ),
    },
  ];
};